export class Exam_Assessment_PlansModel{
    public exam_Assessment_Plan_ID : string = '';
    public exam_Assessment_ID : string = '';
    public assessment_Plan : string = '';
    public created_dt : Date = new Date();
    public created_by : string = '';
    public updated_dt : Date = new Date();
    public updated_by : string = '';
    public number_txt : string = '';
}